import { writable } from 'svelte/store';

import type { AdvancedLinking } from '$lib/types/AdvancedLinking';
import type { Media } from '$lib/types/LayoutData';
import type { QuizMetric } from '$lib/types/QuizMetrics';

export const mediaCookiesAccepted = writable(false);
export const themeBorderRadius = writable('small');
export const embedOptions = writable<{
    isEmbed: boolean;
    preview: boolean;
    header: boolean;
    footer: boolean;
    autoHeight: boolean;
    cookieBanner: boolean;
}>({
    isEmbed: false,
    preview: false,
    header: true,
    footer: true,
    autoHeight: false,
    cookieBanner: true,
});
export const hostViewportHeight = writable(0);
export const quizMetrics = writable<QuizMetric[]>([]);
export const disabledNavigation = writable(false);
export const media = writable<Record<string, Media>>({});
export const advancedLinking = writable<AdvancedLinking>({});
